import { render, staticRenderFns } from "./carrer-data.component.vue?vue&type=template&id=6b405e11&scoped=true&"
import script from "./carrer-data.component.vue?vue&type=script&lang=ts&"
export * from "./carrer-data.component.vue?vue&type=script&lang=ts&"
import style0 from "./carrer-data.component.vue?vue&type=style&index=0&id=6b405e11&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b405e11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
